import { wordEnding } from '@shared/lib';

const kidsAgesOption = Array.from({ length: 18 }).fill(0).map((el, i) => {
    const text = i === 0 ? 'до 1 года' : `${i} ${wordEnding(i, 'год;года;лет')}`;

    return {
        key: i,
        text,
    }
});

export {
    kidsAgesOption,
}